import type { RootState } from '@generalTypes/rootStateTypes';
import { type TypedUseSelectorHook, useSelector } from 'react-redux';

// Define the custom hook
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
